import { useEffect, useRef } from 'react';

export const useAnimationTracker = () => {
  const markers = useRef({
    isDismissAnimationStarted: false,
    isDismissAnimationComplete: false,
  });

  useEffect(
    () => () => {
      if (
        markers.current.isDismissAnimationStarted &&
        !markers.current.isDismissAnimationComplete
      ) {
        // eslint-disable-next-line no-console
        console.error(
          '[Overlay]: The component is unmounted before the fade out animation is completed. Make sure to unmount the component after the `onDismissComplete` callback is called.',
        );
      }
    },
    [],
  );

  return {
    isAnimationComplete: () =>
      markers.current.isDismissAnimationStarted &&
      markers.current.isDismissAnimationComplete,
    markDismissAnimationComplete: () => {
      markers.current.isDismissAnimationComplete = true;
    },
    markDismissAnimationStarted: () => {
      markers.current.isDismissAnimationStarted = true;
    },
  };
};
